require('./_user');

export const theFunction = () => {

};

export default theFunction;



// WEBPACK FOOTER //
// ./src/lib/user.js